import { CoverageFilter } from './coverage-filter.types';

export const COVERAGE_FILTERS: CoverageFilter[] = [
  {
    order: 1,
    active: true,
    keys: ['lunas'],
    inclusive: true,
  },
  {
    order: 2,
    active: true,
    keys: ['asistencia', 'viaje'],
    inclusive: true,
  },
  {
    order: 3,
    active: true,
    keys: ['remolcaje'],
    inclusive: true,
  },
  {
    order: 4,
    active: true,
    keys: ['ayuda', 'técnica', 'carretera'],
    inclusive: true,
  },
  {
    order: 5,
    active: true,
    keys: ['sustitución', 'rueda'],
    inclusive: true,
  },
  {
    order: 6,
    active: true,
    keys: ['prestaciones', 'asegurados', 'inmovilización', 'vehículo', 'avería', 'accidente'],
    inclusive: true,
  },
  {
    order: 7,
    active: true,
    keys: ['rescate'],
    inclusive: true,
  },
];
